
export default {
  middleware: ['authenticated']
}
